// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import initialState from './grid';
import { appReducer } from 'store/behaviors/loader';
import capabilities from './capabilities';

const slice = createSlice({
    name: 'contractType',
    initialState,
    reducers: {
        ...appReducer(capabilities)
    }
});

export default slice.reducer;

export const crmContractTypeActions = slice.actions;
